import type { ExpandedApprovalItem } from 'types/approvals'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material'
import Paper from 'components/@extended/Paper'
import React from 'react'

function formatCurrency(value: number) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

interface AccrualTableProps {
  items: ExpandedApprovalItem[]
}

const AccrualTable: React.FC<AccrualTableProps> = ({ items }) => {
  const theme = useTheme()

  if (!items || items.length === 0) {
    return null
  }

  return (
    <div style={{ width: '100%' }}>
      <Typography variant="h3" mb={2}>
        Accruals
      </Typography>
      <Paper>
        <TableContainer sx={{ maxHeight: 860, minHeight: 200 }}>
          <Table stickyHeader size="small" aria-label="accruals table">
            <TableHead
              sx={{
                '& th': {
                  borderTop: `1px solid ${theme.palette.divider}`,
                  borderBottom: `2px solid ${theme.palette.divider} !important`,
                },
              }}
            >
              <TableRow>
                <TableCell sx={{ minWidth: 150 }}>Name</TableCell>
                <TableCell sx={{ minWidth: 150 }}>Account</TableCell>
                <TableCell sx={{ minWidth: 200 }}>Line Item</TableCell>
                <TableCell align="center" sx={{ minWidth: 120 }}>
                  Balance
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{`${item.accrual?.userFirstName} ${item.accrual?.userLastName}`}</TableCell>
                  <TableCell>{item.accrual?.ledgerAccountLabel}</TableCell>
                  <TableCell>
                    {`${item.accrual?.allocationTableName || ''} | ${item.accrual?.allocationRowName || ''}`}
                  </TableCell>
                  <TableCell align="center">
                    {item.accrual?.payoutOverride || item.accrual?.proratedPayoutAmount
                      ? formatCurrency(item.accrual?.payoutOverride ?? item.accrual?.proratedPayoutAmount ?? 0)
                      : '$0.00'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  )
}

export default AccrualTable
